import X2JS from "x2js";

export async function getWebServiceSoap(url, parametros) {
    const result = await fetch(url, {
        "headers": {
            "accept": "text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9",
            "accept-language": "es-ES,es;q=0.9,en;q=0.8",
            "cache-control": "max-age=0",
            "content-type": "application/x-www-form-urlencoded",
            "upgrade-insecure-requests": "1"
        },
        "referrerPolicy": "strict-origin-when-cross-origin",
        "body": `${parametros}`,
        "method": "POST",
        "mode": "cors",
    });
    return await result.text();
}

export function xmlListToJson(xmlText, listNodeName) {
    const parser = new DOMParser();
    const xmlDom = parser.parseFromString(xmlText, 'text/xml');
    const listNode = xmlDom.querySelector(listNodeName);
    const elements = [...listNode.children];
    const jsonArray = elements.map(element => {
        const result = {};
        [...element.children].forEach(node => {
            result[node.nodeName] = node.textContent;
        });
        return result;
    });
    //console.log(jsonArray);
    return jsonArray;
}

export function xml2json(xmlText){
    const parser = new DOMParser();
    const xmlDom = parser.parseFromString(xmlText, 'text/xml');
    const elements = xmlDom.childNodes[0].children
    const result = {};
    [...elements].forEach(node => {
        result[node.nodeName] = node.textContent;
    });
    return result;
}

export function setTrim(s){
    return String(s).replace(/^[\s|\t|\n]+|[\s|\t|\n]+$/gs,'');
}